<template>
  <b-row class="p-4">
    <b-col cols="12" class="mb-4">
      <div id="container">
        <div id="room-header">
          <h1 id="room-name">FAMILY ROOM</h1>

          <div>USER: {{ rtcUid }}</div>

          <div id="room-header-controls">
            <b-icon
              icon="mic-mute"
              scale="2"
              variant="warning"
              style="margin-right: 25px; cursor: pointer"
            />
            <b-icon
              @click="leaveRoom"
              icon="door-closed-fill"
              scale="2"
              variant="warning"
              style="margin-right: 25px; cursor: pointer"
            />
          </div>
        </div>

        <form id="form">
          <!-- <input name="displayname" type="text" placeholder="Enter display name..."/> -->
          <input
            @click="enterRoom"
            type="submit"
            name="username"
            value="Enter Room"
          />
        </form>

        <div id="members"></div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "HeartBeat_Communicate",
  components: {},
  created() {},
  beforeMount() {},
  mounted() {
    this.lobbyForm = document.getElementById("form");
  },
  props: {
    profile: {
      type: Object,
      required: true,
      default: () => {}
    },
    heartbeat: {
      type: Object,
      required: true,
      default: () => {}
    },
    apps: {
      type: Array,
      required: true,
      default: () => {
        return [];
      }
    }
  },
  computed: {
    ...mapGetters({})
  },
  methods: {},
  data() {
    return {
      appid: "b7b4d36d7d9c4b4396cf138ee19012c4",
      token: null,
      audioTracks: {
        localAudioTrack: null,
        remoteAudioTracks: {}
      },
      rtcClient: null,
      lobbyForm: null
    };
  }
};
</script>

<style lang="scss" scoped>
:root {
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  color-scheme: dark;
  color: rgba(255, 255, 255, 0.87);
  background-color: #242424;
}

a {
  color: #646cff;
  text-decoration: none;
}
a:hover {
  color: #535bf2;
}

body {
  margin: 0;
}

#container {
  max-width: 800px;
  margin: 0 auto;
  padding: 1em;
}

#room-header {
  justify-content: space-between;
  align-items: center;
  padding: 1em 0;
  display: none;
}

#room-header-controls {
  display: flex;
}

#room-header-controls > img {
  margin: 0 2px;
}

.control-icon {
  background-color: indianred;
  border: none;
  padding: 0.5em;
  height: 20px;
  cursor: pointer;
  border-radius: 5px;
}

#members {
  display: flex;
  flex-wrap: wrap;
}

.speaker {
  border: 2px solid #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 120px;
  text-align: center;
  margin: 0.5em;
}

#avatars {
  display: flex;
  flex-wrap: wrap;
  margin: 1em 0;
}

.avatar-selection {
  height: 50px;
  width: 50px;
  object-fit: contain;
  border: 2px solid #fff;
  border-radius: 50%;
  opacity: 0.5;
  cursor: pointer;
  margin: 0.25em;
}

.user-avatar {
  height: 75px;
  width: 75px;
  object-fit: contain;
  border: 2px solid #fff;
  border-radius: 50%;
}

#form input {
  width: 100%;
  padding: 1em;
  margin-bottom: 2em;
  box-sizing: border-box;
}

#form label {
  margin-bottom: 0.5em;
}

#form-fields {
  display: flex;
  flex-direction: column;
}
</style>
